import styled from 'styled-components'
import { SIZE } from '../../common/sizes'
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { InputSuggestable } from '../../components/SearchableDropdown/styles'
import { HEADER_HEIGHT } from 'common/global';

export const IconContainer = styled.div`    
    display: flex;     
    justify-content: center;
    width:35px;   
`

export const HomeContainer = styled.div`
    display: flex;
    flex: 2;
    flex-flow: column;
    height: 100%;
`

export interface HomeProps {
    top: number
}

export const HomeBody = styled.main`
    display:flex;
    overflow-y: auto;
    max-height: ${(props: HomeProps) => props.top && `calc(100vh - ${props.top}px)`};
    background-color: #f8f8f8;
    height: 100%;
`

export const HeaderContainer = styled.div`
    display: flex;
    position: relative;
    width: 100%;
    flex-direction: row;
    height: ${HEADER_HEIGHT};
    padding: 0px 0px 0px ${SIZE.TWO}px;
    align-items: center;
    font-family: Rubik;
    font-size: 34px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #ffffff;
    width: 100%;
    z-index:501;
`

export const HeaderIconContainer = styled.div`
    width: 140px;
    display: flex;
    align-items: center;
`;

export const ActionSection = styled.div`
    width: 325px;
    height: 36px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin: 0 0 0 30px;
    padding-left: ${SIZE.ONE}px;
    // padding: 10px 67px 10px 15px;
    border-radius: 4px;
    border: solid 2px #122442;

    flex-grow: 0;
    font-family: Rubik;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #000000;
`
export interface RotateIconProps {
    colapse: boolean
}
export const RotateIcon = styled.div`
    transition: transform 0.4s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transform: ${(props: RotateIconProps) => !props.colapse ? `rotate(0deg)` : `rotate(180deg)`};
`

export const DatesContainer = styled.div`
    margin: 0px 50px 0px 0px;
    padding: 0px 0px 0px 0px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items:center;
    float: right;
`

export const DatesLastSyncText = styled.span`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-family: Lato;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000;
`

export const DatesLastSyncContainer = styled.div`
    margin: 0px 0px 0px 0px;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
`

export const DatesFromToText = styled.span`
    font-family: Lato;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #122442;
`

export const FromToToolTipContainer = styled.div`
    position: absolute;
    width: 270px;
    z-index: 1000;
    display: none;
    margin: -40px 0px 0px -295px;
    padding: 6px 7.5px 6px 7.6px;
    border-radius: 2px;
    box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
    background-color: #707070;
`;

export const DatesFromToMainContainer = styled.div`
    margin-left: 29px;
    position: relative;
`

export const DatesFromToContainer = styled.div`
    margin: 0px 0px 0px 0px;
    padding: 8px 19px 7px 19px;
    border-radius: 4px;
    border: solid 2px #122442;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    &:hover + ${FromToToolTipContainer} {
        display: flex;
      }
`
export const DatesToolTipContainer = styled.div`
    position: absolute;
    width: 245px;
    z-index: 100;
    display: none;
    margin: 64px 0px 0px -65px;
    padding: 6px 7.5px 6px 7.6px;
    border-radius: 2px;
    box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
    background-color: #707070;
`;


export const DatesToolTipText = styled.div`
  font-family: Rubik;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;


`;

export const DatesInfoIconContainer = styled.div`
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 10px;
    cursor: pointer;
    display:flex;
    &:hover + ${DatesToolTipContainer} {
        display: flex;
      }
`

export const DatesCalendarIconContainer = styled.div`
    margin: 0px 0px 0px 0px;
    padding: 0px 10px 0px 0px;
`


export const ToolTipArea = styled.div`      
      width: 50px;
      height:25px;
      margin-left:-100px;
      position:absolute;
    
`


export const ContactButton = styled.button`
    border-width: 0;
    border-radius: 5px;
    width: ${SIZE.NINETEEN}px;
    height: ${SIZE.FOUR + SIZE.HALF}px;
    flex-grow: 0;
    
    background-color: #4da0ff;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);    
    font-family: Rubik;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;

    &:disabled {
        background-color: #bdbdbd;
        border: none;
    }

    &:hover {
        cursor: pointer;
    }
`

export const Search = styled.div`   
    width: 10px;
`

export const SearchContainer = styled.div`
    display:flex;
    height: 36px;
    width: 31.5%;
    margin-left: 109px;
    ${ InputSuggestable } {
        min-width: 1px;
        width: ${SIZE.FIVE} px;
    }
`

export const Content = styled.div`
    width: 100%;
    display: flex;
    height: 100%;
    position: relative;
`

export const ContentCol = styled.div`
    flex: 2;
`

export const Scroll = styled.div`
    overflow-y: auto;
    max-height: 740px;
    display: flex;
    width: 100%;
`